import React, { Component } from "react";
import {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
} from "../../actions/bookingAction";
import {
  notification,
  getDBFormatedDate,
  withRouter,
  computeBookingEndSlot,
  getUserBrowserTimezone,
} from "../../utils/utility";
import { connect } from "react-redux";
import BookingStep1 from "./booking-step-1";
import BookingStep2 from "./booking-step-2";
import BookingStep3 from "./booking-step-3";
import BookingStep4 from "./booking-step-4";
import BookingStepRedirect from "./booking-step-redirect";
import { trackBookingPageViewed } from "../../utils/productAnalytics";
import { applyEventMarketingTools } from "../../utils/marketingTools";

import "../../assets/bookingeventassets/booking.scss";

import "../../assets/bookingeventassets/calender/fonts/icomoon/style.css";
import "../../assets/bookingeventassets/calender/css/rome.css";
import "../../assets/bookingeventassets/calender/css/style.css";

import logo from "../../assets/bookingeventassets/assets/logo.svg";
import SideLogo from "../../assets/bookingeventassets/assets/sidelogo.svg";
import SideBarFootLogo from "../../assets/bookingeventassets/assets/side_bar_foot_logo.svg";
import Loader from "../../components/Loader/Loader";
import { getBookingThankYouRedirectUrl } from "../../utils/bookingRedirect";

class TimeToEmailBooking extends Component {
  state = {
    step: 1,
    event: {},
    company: {},
    seletedStaffId: null,
    selectedSlot: null,
    endSlotTime: null,
    bookingDate: null,
    firstName: null,
    lastName: null,
    email: null,
    messageFromCustomer: null,
    questionAnswers: [],
    isLoading: false,
    thankYouRedirectUrl: null,
    timezoneValue: "",
  };

  /**
   * on step two submit handler
   * @param {*} firstName
   * @param {*} lastName
   * @param {*} email
   * @param {*} messageFromCustomer
   */
  onSubmitStepTwo = (
    firstName,
    lastName,
    email,
    messageFromCustomer,
    questionAnswers,
    addOns = [],
    pricing = [],
    isEventPaid = "E"
  ) => {
    const _this = this;
    this.setState(
      {
        firstName,
        lastName,
        email,
        messageFromCustomer,
        questionAnswers,
      },
      () => {
        if (isEventPaid === "D") {
          _this.onScheduleEvent({});
        }
      }
    );
  };

  /**
   * on update step
   * @param {*} step
   */
  onUpdateStep = (step) => {
    this.setState({
      step,
    });
  };

  onBookingComplete = (bookingStatus = "A") => {
    const { event, company } = this.state;
    const status = bookingStatus || "A";
    const thankYouRedirectUrl =
      status === "P" ? null : getBookingThankYouRedirectUrl(event, company);
    this.setState({
      thankYouRedirectUrl,
      bookingStatus: status,
      step: 4,
    });
  };

  onThankYouRedirectPhase = () => {
    this.setState({ step: 5 });
  };

  /**
   * on schedule event
   * @param {*} data
   */
  onScheduleEvent = (data) => {
    const _this = this;
    const {
      firstName,
      lastName,
      email,
      messageFromCustomer,
      questionAnswers,
      seletedStaffId,
      selectedSlot,
      event,
      bookingDate,
      company,
      timezoneValue,
    } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;

    const endSlot = computeBookingEndSlot(
      bookingDate,
      selectedSlot,
      event.timeslot,
      timezoneValue
    );

    _this.setState({
      endSlotTime: endSlot,
    });

    //console.log("end Slot", endSlot);

    console.log("event", event);

    console.log(event.is_event_paid, event.is_event_paid === "E");

    if (event.is_event_paid === "E") {
      // save paid event

      const { savePaidBooking } = this.props;

      const [expMonth, expYear] = data.cardDetails.card_expiry.split("/");

      const bookingDetails = {
        card_number: data.cardDetails.card_number,
        exp_month: expMonth,
        exp_year: expYear,
        cvc: data.cardDetails.cvc,
        event_id: event.id,
        booking_date_time: bookingDateTime,
        start_time: selectedSlot + ":00",
        end_time: endSlot + ":00",
        message_from_customer: messageFromCustomer,
        reminder_phone_no: "32424",
        business_id: company.id,
        staff_id: 1, //seletedStaffId,
        email: email,
        first_name: firstName,
        last_name: lastName,
        booking_addons: [...data.addOns],
        booking_pricing: [...data.pricing],
        questions: [...questionAnswers],
        timezone: timezoneValue,
      };

      console.log("data", bookingDetails);

      savePaidBooking({
        data: {
          ...bookingDetails,
        },
        onSuccess: (data) => {
          _this.onBookingComplete(data?.booking_status);
          console.log("data", data);
        },
        onError: (error) => {
          /*
          this.setState({
            isLoading: false,
            errorMessage: error,
          });
          */
        },
      });
    } else {
      // save free event
      const { saveFreeBooking } = this.props;
      const bookingDetails = {
        event_id: event.id,
        booking_date_time: bookingDateTime,
        start_time: selectedSlot + ":00",
        end_time: endSlot + ":00",
        message_from_customer: messageFromCustomer,
        reminder_phone_no: "32424",
        business_id: company.id,
        staff_id: 1, //seletedStaffId,
        email: email,
        first_name: firstName,
        last_name: lastName,
        questions: [...questionAnswers],
        timezone: timezoneValue,
      };

      saveFreeBooking({
        data: {
          ...bookingDetails,
        },
        onSuccess: (data) => {
          _this.onBookingComplete(data?.booking_status);
          console.log("data", data);
        },
        onError: (error) => {
          /*
          this.setState({
            isLoading: false,
            errorMessage: error,
          });
          */
        },
      });
    }
  };

  /**
   * execute when component inserted in dom
   */
  componentDidMount() {
    const _this = this;
    const { router, getEvent } = this.props || {};
    const { params } = router || {};
    const { slug, dated, slot } = params || {};

    _this.setState({
      isLoading: true,
    });

    getEvent({
      data: {
        slug,
      },
      onSuccess: function (response) {
        const normalizedDate = dated ? getDBFormatedDate(new Date(dated)) : null;
        _this.setState({
          event: response.event,
          company: response.company,
          selectedSlot: slot,
          bookingDate: normalizedDate,
          timezoneValue: getUserBrowserTimezone(),
          step: 2,
          isLoading: false,
        });

        applyEventMarketingTools(
          response.seo,
          response.event?.event_name || response.event?.event_title
        );

        // Ticket 16 — fail-open page view (server resolves business from slug)
        trackBookingPageViewed(response.event?.event_url || slug);
      },
      onError: (error) => {
        notification.error(error.response.data.message);
      },
    });
  }

  render() {
    const {
      step,
      event,
      company,
      selectedSlot,
      endSlotTime,
      bookingDate,
      isLoading,
      thankYouRedirectUrl,
      bookingStatus,
    } = this.state;
    const bookingData = {
      selectedSlot,
    };

    return (
      <>
        <Loader isShowLoader={isLoading} />
        <div className="container-fluid">
          <nav className="navbar navbar-expand-sm justify-content-center top_nav shadow">
            <a className="navbar-brand" href="#">
              <img src={logo} alt="Logo" style={{ width: "100%" }} />
            </a>
          </nav>
        </div>
        <div className="main_div">
          <div className="left_div">
            <nav className="navbar side_navbar">
              <ul className="navbar-nav side_bar_ul">
                <li className="nav-item">
                  <img src={SideLogo} />
                </li>
                <li className="nav-item">
                  <h2>{company.company_name}</h2>
                  <p>{company.company_description}</p>
                </li>
                <li className="nav-item">
                  <h2>Contact Details</h2>
                  <p className="sub_head">
                    <span>Email:</span> <br />
                    {company.company_email}
                  </p>
                  <p className="sub_head">
                    <span>Phone No:</span> <br />
                    {company.company_phone_no}
                  </p>
                  <p className="sub_head">
                    <span>Address</span> <br />
                    {company.company_address}
                  </p>

                  <div className="row side_bar_foot_img_div">
                    <div className="col-12 side_bar_foot_logo_img">
                      <img src={SideBarFootLogo} />
                    </div>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
          <div className="right_div">
            {/* {step === 1 && (
              <BookingStep1
                event={event}
                onSeletStaff={this.onSeletStaff}
                onSelectSlot={this.onSelectSlot}
                onSelectDate={this.onSelectDate}
                onUpdateStep={this.onUpdateStep}
              />
            )} */}
            {step === 2 && (
              <BookingStep2
                onSubmitStepTwo={this.onSubmitStepTwo}
                onScheduleEvent={this.onScheduleEvent}
                onUpdateStep={this.onUpdateStep}
                event={event}
                data={bookingData}
              />
            )}
            {step === 3 && (
              <BookingStep3
                onScheduleEvent={this.onScheduleEvent}
                event={event}
              />
            )}
            {step === 4 && (
              <BookingStep4
                event={event}
                selectedSlot={selectedSlot}
                endSlotTime={endSlotTime}
                bookingDate={bookingDate}
                bookingStatus={bookingStatus}
                redirectUrl={thankYouRedirectUrl}
                onConfirmationComplete={
                  thankYouRedirectUrl ? this.onThankYouRedirectPhase : null
                }
              />
            )}
            {step === 5 && thankYouRedirectUrl && (
              <BookingStepRedirect redirectUrl={thankYouRedirectUrl} />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  getEvent,
  savePaidBooking,
  saveFreeBooking,
})(withRouter(TimeToEmailBooking));
